import React from 'react';

export default function UnsplashBlankIcon({width = "none", height = "none"}) {
  return (  
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24.9708" cy="25.224" r="24.2723" fill="white" stroke="#474747" stroke-width="0.990706"/>
      <g clip-path="url(#clip0_3825_17393)">
        <path d="M36.859 23.8534V37.1105H13.082V23.8534H20.5721V30.4819H29.3688V23.8534H36.859ZM29.3689 13.3374H20.5722V19.966H29.3689V13.3374Z" fill="black"/>
      </g>
      <defs>
        <clipPath id="clip0_3825_17393">
          <rect width="23.777" height="23.777" fill="white" transform="translate(13.082 13.3354)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
